import gql from 'graphql-tag';

import { FRAGMENT_FULL_HERO } from 'src/modules/layout/components/block/fullHero/queries';
import { FRAGMENT_HERO } from 'src/modules/layout/components/block/hero/queries';
import { FRAGMENT_BANNER } from 'src/modules/global/components/banner/queries';
// import { FRAGMENT_CTA_BUTTON } from 'src/modules/global';

export const QUERY_HOMEPAGE = gql`
  query Homepage {
    homepage {
      hero {
        ...fullHero
      }
      teaser_left_title_en
      teaser_left_title_de
      teaser_left_subline_en
      teaser_left_subline_de
      teaser_left_cta {
        ...ctaButton
      }
      teaser_left_image {
        alternativeText
        url
      }
      teaser_right_title_en
      teaser_right_title_de
      teaser_right_subline_en
      teaser_right_subline_de
      teaser_right_cta {
        ...ctaButton
      }
      teaser_right_image {
        alternativeText
        url
      }
      block_left_title_en
      block_left_title_de
      block_left_subline_en
      block_left_subline_de
      block_left_cta {
        ...ctaButton
      }
      block_left_image {
        alternativeText
        url
      }
      block_right_title_en
      block_right_title_de
      block_right_subline_en
      block_right_subline_de
      block_right_cta {
        ...ctaButton
      }
      block_right_image {
        alternativeText
        url
      }
      banner_top {
        ...banner
      }
      banner_bottom {
        ...banner
      }
    }
    articles(
      where: { _or: [{ reference_null: true }, { featured_project: true }] }
      limit: 3
      sort: "published_at:desc"
    ) {
      slug
      article_category {
        name_de
        name_en
      }
      hero {
        ...hero
      }
      reference {
        reference_category {
          id
          name_en
          name_de
        }
      }
    }
  }

  fragment ctaButton on ComponentCtaButton {
    text_en
    text_de
    url
    external_link
    isButton: button
    overlay
    download {
      url
    }
  }
  ${FRAGMENT_FULL_HERO}
  ${FRAGMENT_HERO}
  ${FRAGMENT_BANNER}
`;
